import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { EditProfileStateData } from './types';

const initialState: EditProfileStateData = {
	data: {
		data: {
			message: '',
			result: {
				a_home_number: '',
				abon_pay_for_today: '',
				account: {
					alert_last_date_limit: '',
					balance: '',
					balance_adjust: '',
					balance_buh: '',
					bonus_score: '',
					credit: '',
					credit_add: '',
					credit_adjust: '',
					credit_adjust_add: '',
					currency: {},
					debit: '',
					do_notify_changes: '',
					hack_limit: '',
					id: '',
					limit: '',
					limit_warning: '',
					ostatok: '',
					ostatok_add: '',
					overlimit_sum: '',
					pk: '',
					unlimited: '',
					unlimited_date: '',
					__currency: '',
					__self: '',
				},
				activate_date: '',
				agent_scheme: '',
				alert_crm: '',
				alert_hdsk: '',
				alert_last_date: '',
				allow_internet: '',
				atol_config: '',
				auto_account: '',
				auto_account_interval: '',
				autopay_pay_log: '',
				billing_settings: '',
				category: {
					do_notify_changes: '',
					id: '',
					name: '',
					pk: '',
					__self: '',
				},
				child_folders_count: '',
				childs_count: '',
				code1c: '',
				company: '',
				contract_number: '',
				contract_prefix: '',
				create_date: '',
				create_date_system: '',
				currency: {
					do_notify_changes: '',
					id: '',
					name: '',
					pk: '',
					primary_cur: '',
					short_name: '',
					update_server: '',
					__self: '',
				},
				deleted: '',
				disabled_date: '',
				disabled_date_end: '',
				discount: '',
				do_notify_changes: '',
				email: '',
				enabled: '',
				generated_contract_number: '',
				home: {
					SUGGEST_TO_HOME_MAPPING: {},
					URL: '',
					caretaker: '',
					city: '',
					city_type: '',
					connect_date: '',
					country: '',
					district: '',
					district_type: '',
					do_notify_changes: '',
					fields_empty_null: [],
					fields_empty_number: [],
					fields_empty_string: [],
					home_types: {},
					id: '',
					kladr_id: '',
					kladr_sync: '',
					kladr_sync_date: '',
					managment_company: '',
					number_of_apartments: '',
					number_of_entrances: '',
					okato: '',
					parent: '',
					pk: '',
					pull: '',
					region: '',
					region_type: '',
					s_liter: '',
					s_liter_type: {},
					s_number: '',
					s_number_type: '',
					settlement: '',
					settlement_type: '',
					street: '',
					street_type: {},
					unrestricted_value: '',
					zip_code: '',
					__city_type: '',
					__home_types: '',
					__s_liter_type: '',
					__self: '',
					__street_type: '',
				},
				home_entrance: '',
				id: '',
				imported_id: '',
				ip_pull: '',
				is_folder: '',
				level: '',
				lft: '',
				loyalty: '',
				main: '',
				master: '',
				migration_info: '',
				minimal_pay_sum: '',
				modified: '',
				multi_act: '',
				name: '',
				nds: '',
				need_recalc: '',
				need_refresh_cache: '',
				next_auto_acount: '',
				object_status: {
					apply_date: '',
					date_status_change: '',
					do_notify_changes: '',
					id: '',
					object_id: '',
					object_name: '',
					pk: '',
					status: {},
					substatus: '',
					__self: '',
					__status: '',
				},
				operator: {
					a_home_number: '',
					abon_pay_for_today: '',
					account: {},
					activate_date: '',
					agent_scheme: '',
					alert_crm: '',
					alert_hdsk: '',
					alert_last_date: '',
					allow_internet: '',
					atol_config: '',
					auto_account: '',
					auto_account_interval: '',
					autopay_pay_log: '',
					billing_settings: {},
					category: {},
					child_folders_count: '',
					childs_count: '',
					code1c: '',
					company: '',
					contract_number: '',
					contract_prefix: '',
					create_date: '',
					create_date_system: '',
					currency: {},
					deleted: '',
					disabled_date: '',
					disabled_date_end: '',
					discount: '',
					do_notify_changes: '',
					email: '',
					enabled: '',
					generated_contract_number: '',
					home: '',
					home_entrance: '',
					id: '',
					imported_id: '',
					ip_pull: '',
					is_folder: '',
					level: '',
					lft: '',
					loyalty: '',
					main: '',
					master: '',
					migration_info: '',
					minimal_pay_sum: '',
					modified: '',
					multi_act: '',
					name: '',
					nds: '',
					need_recalc: '',
					need_refresh_cache: '',
					next_auto_acount: '',
					object_status: {},
					operator: {},
					own_disabled_end: '',
					own_disabled_start: '',
					parent: {},
					penalties: '',
					personal_act: '',
					pk: '',
					post_pay_credit: '',
					prebilled: '',
					promise_countpermonth: '',
					promise_date_end: '',
					promise_pay: '',
					push_token: '',
					real_limit: '',
					recomend_pay_sum: '',
					recomend_pay_sum_post: '',
					recursive_childs_count: '',
					recursive_deleted_childs_count: '',
					rewrite_inherit: '',
					rght: '',
					security_alert: '',
					send_act: '',
					sms: '',
					sync1c: '',
					tarif: {},
					tarif_next: '',
					tarif_next_date: '',
					tarif_next_date_prev: '',
					tarif_notified: '',
					tree_id: '',
					usluga_range_type: '',
					__account: '',
					__billing_settings: '',
					__category: '',
					__currency: '',
					__object_status: '',
					__operator: '',
					__parent: '',
					__self: '',
					__tarif: '',
				},
				own_disabled_end: '',
				own_disabled_start: '',
				parent: {
					a_home_number: '',
					abon_pay_for_today: '',
					account: {},
					activate_date: '',
					agent_scheme: '',
					alert_crm: '',
					alert_hdsk: '',
					alert_last_date: '',
					allow_internet: '',
					atol_config: '',
					auto_account: '',
					auto_account_interval: '',
					autopay_pay_log: '',
					billing_settings: '',
					category: {},
					child_folders_count: '',
					childs_count: '',
					code1c: '',
					company: '',
					contract_number: '',
					contract_prefix: '',
					create_date: '',
					create_date_system: '',
					currency: {},
					deleted: '',
					disabled_date: '',
					disabled_date_end: '',
					discount: '',
					do_notify_changes: '',
					email: '',
					enabled: '',
					generated_contract_number: '',
					home: '',
					home_entrance: '',
					id: '',
					imported_id: '',
					ip_pull: '',
					is_folder: '',
					level: '',
					lft: '',
					loyalty: '',
					main: '',
					master: '',
					migration_info: '',
					minimal_pay_sum: '',
					modified: '',
					multi_act: '',
					name: '',
					nds: '',
					need_recalc: '',
					need_refresh_cache: '',
					next_auto_acount: '',
					object_status: {},
					operator: '',
					own_disabled_end: '',
					own_disabled_start: '',
					parent: {},
					penalties: '',
					personal_act: '',
					pk: '',
					post_pay_credit: '',
					prebilled: '',
					promise_countpermonth: '',
					promise_date_end: '',
					promise_pay: '',
					push_token: '',
					real_limit: '',
					recomend_pay_sum: '',
					recomend_pay_sum_post: '',
					recursive_childs_count: '',
					recursive_deleted_childs_count: '',
					rewrite_inherit: '',
					rght: '',
					security_alert: '',
					send_act: '',
					sms: '',
					sync1c: '',
					tarif: {},
					tarif_next: '',
					tarif_next_date: '',
					tarif_next_date_prev: '',
					tarif_notified: '',
					tree_id: '',
					usluga_range_type: '',
					__account: '',
					__category: '',
					__currency: '',
					__object_status: '',
					__parent: '',
					__self: '',
					__tarif: '',
				},
				penalties: '',
				personal_act: '',
				pk: '',
				post_pay_credit: '',
				prebilled: '',
				promise_countpermonth: '',
				promise_date_end: '',
				promise_pay: '',
				push_token: '',
				real_limit: '',
				recomend_pay_sum: '',
				recomend_pay_sum_post: '',
				recursive_childs_count: '',
				recursive_deleted_childs_count: '',
				rewrite_inherit: '',
				rght: '',
				security_alert: '',
				send_act: '',
				sms: '',
				sync1c: '',
				tarif: {
					act_shift: '',
					agent_show_mbyte: '',
					allow_change_activated: '',
					allow_change_from: '',
					allow_change_negbal: '',
					allow_change_to: '',
					allow_limit: '',
					allways_apply: '',
					archived: '',
					change_cost: '',
					change_group: '',
					change_minday: '',
					change_only_end_day: '',
					change_only_end_period: '',
					change_renew_ip: '',
					default_nat: '',
					do_notify_changes: '',
					free_own_block_period: '',
					id: '',
					iface_id: '',
					imported_id: '',
					inactive_days: '',
					inactive_group: '',
					inactive_tarif: '',
					is_used: '',
					limit: '',
					limit_block_sum: '',
					migration_info: '',
					name: '',
					nat_dyn_end: '',
					nat_dyn_start: '',
					operator: '',
					own_disabled_cost: '',
					own_disabled_countpermounth: '',
					own_disabled_maxdays: '',
					own_disabled_mindays: '',
					own_disabled_usluga: '',
					pk: '',
					plan_comment: '',
					promise_countpermonth: '',
					promise_days: '',
					promise_maxday: '',
					promise_maxpay: '',
					promise_mincreditday: '',
					promise_minpayday: '',
					promise_need_pay_after_prev: '',
					promise_pay_only_this_month: '',
					promise_pay_safeday: '',
					promo_days: '',
					promo_month: '',
					promo_next: '',
					pull_dynamic_ip: '',
					pull_dynamic_ip_forceclear: '',
					reserve_plan: '',
					show_www: '',
					tarif_group: '',
					tarif_group_mask: '',
					transfer_allow: '',
					transfer_more_money_end_day: '',
					transfer_only_more_money: '',
					updatetime: '',
					users_balance_warning: '',
					users_limit: '',
					users_limit_warning: '',
					usluga_allow_all: '',
					usluga_range_type: {},
					__self: '',
					__usluga_range_type: '',
				},
				tarif_next: '',
				tarif_next_date: '',
				tarif_next_date_prev: '',
				tarif_notified: '',
				tree_id: '',
				user_ip: [],
				user_phone: [],
				usluga_range_type: { do_notify_changes: '', id: '', name: '', operator: '', pk: '', __self: '' },
				__account: '',
				__category: '',
				__currency: '',
				__home: '',
				__object_status: '',
				__operator: '',
				__parent: '',
				__self: '',
				__tarif: '',
				__usluga_range_type: '',
			},
			__result: '',
			error: '',
		},
		error: null,
	},
	loading: false,
	error: '',
};

export const fetchEditProfile = createAsyncThunk(
	'api/fetchEditProfile',
    	({ sessionId, email, phone, password }: { sessionId: string; email: string; phone: string; password: string }) => {
    	    return api.fetchEditProfile(sessionId, email, phone, password);
    	},
);

const editProfileSlice = createSlice({
	name: 'editProfile',
	initialState,
	reducers: {
		clearEditResponse(state) {
			state.data = initialState.data;
		},
	},
	extraReducers(builder) {
		builder
			.addCase(fetchEditProfile.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchEditProfile.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchEditProfile.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при загрузке';
			});
	},
});

export const { clearEditResponse } = editProfileSlice.actions;
export default editProfileSlice.reducer;
